import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import Moment from 'moment';
import ScrollArea from 'react-scrollbar';
import Loader from './Loader';
import NoResults from './NoResults';

@inject('CommunicationNoticeStore', 'NotificationStore') @observer
class CommunicationNotices extends Component {
  componentWillMount() {
    const { CommunicationNoticeStore, NotificationStore } = this.props;
    CommunicationNoticeStore.fetchData();
    setTimeout(() => NotificationStore.readNotifications('notice'), 2000);

  }

  render() {
    const { CommunicationNoticeStore, match: { url } } = this.props;
    return (
      <ScrollArea style={{ height: 400 }} stopScrollPropagation={true}>
        {!CommunicationNoticeStore.loaded && <Loader />}

        {CommunicationNoticeStore.loaded &&
          !CommunicationNoticeStore.notices.length &&
          <NoResults text="Não há comunicados no momento" />}
        <ul className="notice-list">
          {CommunicationNoticeStore.notices.map(notice => {
            return (
              <li key={notice.id}>
                <Link to={`${url}/avisos/${notice.slug}`}>
                  <div className="notice-wrapper">
                    {notice.image && (
                      <div className="image-mask">
                        <img src={notice.image} />
                      </div>
                    )}
                    <div className="notice-content">
                      <span className="notice-date">
                        <img src={require('../../img/icon-calendar.svg')} className="icon-calendar" alt="" />
                        {Moment(notice.created).local().format("DD/MM/YYYY [às] HH:mm")}
                      </span>
                      <p>{notice.title}</p>
                      <span className="notice-button">Veja mais</span>
                    </div>
                  </div>
                </Link>
              </li>
            );
          })}
        </ul>
      </ScrollArea>
    );
  }
};

export default withRouter(CommunicationNotices);



// WEBPACK FOOTER //
// ./src/components/notices/CommunicationNotices.js